import { action } from 'typesafe-actions';
import { Types, IUser, IUserPreference, ISaveUser } from './types';

export const tokenValidate = () => action(Types.TOKEN_VALIDATE);
export const tokenValidateSuccess = (userId: string, expecialSteel: boolean) =>
  action(Types.TOKEN_VALIDATE_SUCCESS, { userId, expecialSteel });
export const tokenValidateFailure = (error: unknown) =>
  action(Types.TOKEN_VALIDATE_FAILURE, { error });

export const loadUser = (userId: string) => action(Types.LOAD_USER, { userId });
export const loadUserSuccess = (user: IUser) =>
  action(Types.LOAD_USER_SUCCESS, { user });
export const loadUserFailure = (error: unknown) =>
  action(Types.LOAD_USER_FAILURE, { error });

export const updateUserPreferences = (userPreference: IUserPreference) =>
  action(Types.UPDATE_USER_PREFERENCES, { userPreference });

export const saveUser = ({
  user,
  userPreference,
  sendOrdersToEmail,
  sendFinancialToEmail,
  userAcceptNotification,
  improvementResearch,
  privacyTerms,
  userName,
  improvementResearchNps,
  jorneySurveyShowcaseStatus,
  jorneySurveyHistoryStatus,
  jorneySurveyItemsStatus,
  jorneySurveySheetStatus,
  gerdauProModal
}: ISaveUser) => {
  return action(Types.SAVE_USER, {
    user,
    userPreference,
    sendOrdersToEmail,
    sendFinancialToEmail,
    userAcceptNotification,
    improvementResearch,
    privacyTerms,
    userName,
    improvementResearchNps,
    jorneySurveyShowcaseStatus,
    jorneySurveyHistoryStatus,
    jorneySurveyItemsStatus,
    jorneySurveySheetStatus,
    gerdauProModal
  });
};
export const saveUserSuccess = (user: IUser) =>
  action(Types.SAVE_USER_SUCCESS, { user });
export const saveUserFailure = (error: unknown) =>
  action(Types.SAVE_USER_FAILURE, { error });

export const swapCustomerViewType = (user: IUser) =>
  action(Types.SWAP_USER_VIEW_TYPE, { user });

export const userLogout = (toCallLogout = true) =>
  action(Types.USER_LOGOUT, { toCallLogout });

// dispara a limpeza do usuário anterior e recarrega os dados do usuário recém-autenticado.
// keepSession=true: mesmo usuário reautenticando — preserva a jornada (não limpa estado/localStorage).
export const resetUserSession = ({ keepSession = false } = {}) =>
  action(Types.RESET_USER_SESSION, { keepSession });
